import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService(router) {
        this.router = router;
        this.initialized = false;
    }
    AnalyticsService.prototype.init = function (trackingId) {
        if (!this.initialized && environment.production) {
            try {
                var script1 = document.createElement('script');
                script1.async = true;
                script1.src = "https://www.googletagmanager.com/gtag/js?id=" + trackingId;
                document.head.appendChild(script1);
                var script2 = document.createElement('script');
                script2.innerHTML = "\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n\n          gtag('config', '" + trackingId + "');\n        ";
                document.body.appendChild(script2);
                this.trackingId = trackingId;
                this.initialized = true;
                this.listenForRouteChanges();
            }
            catch (ex) {
                console.error('Error appending google analytics');
                console.error(ex);
            }
        }
    };
    AnalyticsService.prototype.event = function (eventName, params) {
        if (typeof gtag === 'function') {
            gtag('event', eventName, params);
        }
    };
    AnalyticsService.prototype.listenForRouteChanges = function () {
        var _this = this;
        this.router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                if (typeof gtag === 'function') {
                    gtag('config', _this.trackingId, {
                        'page_path': event.urlAfterRedirects,
                    });
                    console.log('Sending Google Analytics hit for route', event.urlAfterRedirects);
                    console.log('Property ID', _this.trackingId);
                }
            }
        });
    };
    AnalyticsService.ngInjectableDef = i0.defineInjectable({ factory: function AnalyticsService_Factory() { return new AnalyticsService(i0.inject(i1.Router)); }, token: AnalyticsService, providedIn: "root" });
    return AnalyticsService;
}());
export { AnalyticsService };
